import createReactComponent from '../createReactComponent';
export default createReactComponent('player-skip-back', 'IconPlayerSkipBack', [
  ['path', { d: 'M20 5v14l-12 -7z', key: 'svg-0' }],
  ['path', { d: 'M4 5l0 14', key: 'svg-1' }],
]);
